import './formatters.js';

// Configurações globais para plugins
jconfirm.pluginDefaults.useBootstrap = false;
Dropzone.autoDiscover = false;

window.showNotification = function showNotification(message, config = {}) {
    if (!message) {
        throw new Error('Mensagem não informada!');
    }

    if (typeof config !== 'object') {
        throw new Error('Parâmetro de configuração inválido!');
    }

    config.duration = config.duration ?? 8000;
    config.type = config.type ?? 'success';

    if (!['error', 'success', 'warning'].includes(config.type)) {
        throw new Error('Tipo de notificação inválido!');
    }

    const notification = document.getElementById(`${config.type}-notification-template`)
        .content
        .querySelector('.alert')
        .cloneNode(true);

    notification.querySelector('.alert-message').insertAdjacentHTML('beforeend', message);

    const openDialog = document.querySelector('dialog[open]');

    // Se existe uma dialog com o atributo open (aberta), precisamos fazer o append da notificação na dialog
    // caso contrário será exibida atrás do overlay
    if (openDialog) {
        notification.classList.add('absolute', 'right-0', 'bottom-0');
        openDialog.appendChild(notification);

    } else {
        document.querySelector('.notification-container')
            .appendChild(notification);
    }

    setTimeout(() => {
        notification.classList.add('opacity-0', 'invisible');
        setTimeout(() => notification.remove(), 500);
    }, config.duration);
};

window.showAlert = function showAlert (message, config = {}, callback = () => {}) {
    if (!message) throw new Error('É necessário informar a mensagem para o alerta!');

    const defaultType = 'info';
    const configAlertTypes = {
        'danger': {
            type: 'red',
            title: 'Erro!',
            titleColor: 'text-red-500',
            btnClass: 'btn-error'
        },
        'warning': {
            type: 'orange',
            title: 'Atenção!',
            titleColor: 'text-yellow-600',
            btnClass: 'btn-warning'
        },
        'success': {
            type: 'green',
            title: 'Sucesso!',
            titleColor: 'text-green-500',
            btnClass: 'btn-success'
        },
        'info': {
            type: 'blue',
            title: 'Informação!',
            titleColor: 'text-sky-500',
            btnClass: 'btn-info'
        },
    }

    $.alert({
        container: document.querySelector('dialog[open]') ? 'dialog' : 'body',
        title: config.title ?? configAlertTypes[config.type ?? defaultType].title,
        titleClass: `!text-2xl ${configAlertTypes[config.type ?? defaultType].titleColor}`,
        content: message,
        type: configAlertTypes[config.type ?? defaultType].type,
        typeAnimated: false,
        bgOpacity: .45,
        autoClose: 'close|8000',
        buttons: {
            close: {
                text: 'OK',
                btnClass: `btn btn-outline btn-md ${configAlertTypes[config.type ?? defaultType].btnClass}`,
                action: callback
            }
        }
    });
};

window.showConfirm = function showConfirm(message, action = () => {}, config = {}, closeAction = () => {}) {
    if (!message) throw new Error('É necessário informar a mensagem para o alerta!');

    if (typeof action !== 'function' || typeof closeAction !== 'function') {
        throw new Error('A ação/função que será executada ao confirmar não é uma função válida!');
    }

    const defaultType = 'info';
    const configAlertTypes = {
        'danger': {
            type: 'red',
            titleColor: 'text-red-500',
            btnClass: 'btn-error'
        },
        'warning': {
            type: 'orange',
            titleColor: 'text-yellow-600',
            btnClass: 'btn-warning'
        },
        'success': {
            type: 'green',
            titleColor: 'text-green-500',
            btnClass: 'btn-success'
        },
        'info': {
            type: 'blue',
            titleColor: 'text-sky-500',
            btnClass: 'btn-info !border-sky-500'
        },
    }

    const buttons = {
        confirm: {
            text: config.confirmButtonLabel ?? 'Confirmar',
            btnClass: `btn btn-outline btn-md ${configAlertTypes[config.type ?? defaultType].btnClass}`,
            action: action
        },
        close: {
            text: config.closeButtonLabel ?? 'Cancelar',
            btnClass: 'btn btn-outline btn-md btn-default',
            action: closeAction
        }
    };

    $.confirm({
        container: document.querySelector('dialog[open]') ? 'dialog' : 'body',
        title: config.title ?? 'Confirmar?',
        titleClass: `!text-2xl ${configAlertTypes[config.type ?? defaultType].titleColor}`,
        content: message + (config.additionalMessage ? '<br><br>' + config.additionalMessage : ''),
        type: configAlertTypes[config.type ?? defaultType].type,
        typeAnimated: false,
        buttons
    })
};

window.Spinner = (function () {
    const spinnerElement = document.createElement('div');
    spinnerElement.className = 'spinner-container';
    spinnerElement.innerHTML = `
        <div class="spinner-body">
            <span class="loading loading-infinity loading-xl"></span> <span class="message">Processando</span>
        </div>
    `;

    let _targetEl = null;

    return {
        show: function (target = null, message = null) {
            if (target) {
                _targetEl = document.querySelector(target);
                _targetEl.appendChild(spinnerElement);

            } else {
                document.body.appendChild(spinnerElement);
            }

            if (message) {
                spinnerElement.querySelector('.message').textContent = message;
            }

            spinnerElement.style.display = 'flex';
        },

        hide: function () {
            spinnerElement.style.display = 'none';

            try {
                _targetEl.removeChild(spinnerElement);

            } catch (error) {
                if (document.body.contains(spinnerElement)) {
                    document.body.removeChild(spinnerElement);
                }
            }
        }
    };
})();

window.printFile = function printFile(pathToFile) {
    let iframe = window._printIframe;

    if (!window._printIframe) {
        window._printIframe = document.createElement('iframe');
        iframe = window._printIframe;
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
        };
    }

    iframe.src = pathToFile;
};

window.getDateFormattedToYMD = function getDateFormattedToYMD(date = new Date()) {
    const year = date.toLocaleString('default', {year: 'numeric'});
    const month = date.toLocaleString('default', {
        month: '2-digit',
    });
    const day = date.toLocaleString('default', {day: '2-digit'});

    return [year, month, day].join('-');
}

window.addDaysToDate = (dateString, days = 1) => {
    const date = new Date(dateString + 'T00:00:00');
    date.setDate(date.getDate() + days);
    return date;
}

window.slugfy = function slugfy(string) {
    if (!string || string.trim() === '' || typeof string !== 'string') {
        throw new Error('Parâmetro inválido. Verifique se o parâmetro é uma string.');
    }

    return string
        .split()
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-');
}

window.copyToClipboard = function copyToClipboard(text) {
    if (!text) {
        throw new Error('You must enter the text to be copied as a parameter!');
    }

    if (!navigator.clipboard) {
        throw new Error('Your browser does not support copy to clipboard function!');
    }

    navigator.clipboard.writeText(text)
        .then(function() {
            showNotification('Link copiado copiado com sucesso!', { duration: 5000 });
        })
        .catch(error => {
            showNotification('Não foi possível copiar o link!', { type: 'error' });
            console.error('Async: Could not copy text: ', error)
        });
}

window.logErrorMessage = function logErrorMessage(error) {
    console.error(error);
    Spinner.hide();
    showNotification(error.response?.data?.message ?? error.message ?? error ?? 'Ocorreu um problema com a operação. Por favor, tente novamente.', {
        type: 'error'
    });
}

$(function () {
    /**
     * Configura o axios para exibir o loading durante as requisições
     */
    axios.interceptors.request.use(config => {

        if (!config.params || !config.params.withoutSpinner) {
            const openDialog = document.querySelectorAll('dialog[open]');

            if (openDialog.length) {
                const dialog = Array.from(openDialog).pop();
                Spinner.show(`#${dialog.id}`);

            } else {
                Spinner.show();
            }
        }

        return config;
    });

    /**
     * Configura o axios para ocultar o loading durante as respostas
     */
    axios.interceptors.response.use(response => {
        //Só ocultamos o loading caso não seja para fazer redirect na página. Se tiver redirect, deixamos o loading pois
        //no redirect irá ser encerrado.
        if (!response.data.redirect) {
            Spinner.hide();
        }

        return response;
    });

    /**
     * Inicializa o plugin select2
     */
    window.initSelect2Plugin = function initSelect2Plugin(dialog = null) {

        // Essa função corrige o problema com a abertura do select2 dentro de dialogs do HTML
        (function fixSelec2InsideDialogs() {
            function addAttribute(dialog) {
                const select2Inputs = dialog.querySelectorAll('.select2');

                select2Inputs.forEach(input => {
                    input.setAttribute('data-dropdown-parent', `#${dialog.id}`);
                });
            }

            if (dialog) {
                addAttribute(dialog);
            }

            const dialogs = document.querySelectorAll('dialog');
            dialogs.forEach(dialog => addAttribute(dialog));
        })();

        const id = dialog ? '#' + dialog?.id : '';

        //Inicializa elementos select2 em modo select
        $(`${id} select.select2:not(.allow-clear):not(.tags):not(.with-create-tag)`).select2({
            language: 'pt-BR',
            placeholder: 'Selecione...'
        });

        //Inicializa o select2 com a opção de limpar a seleção
        $(`${id} select.select2.allow-clear`).select2({
            language: 'pt-BR',
            allowClear: true,
            placeholder: 'Selecione...'
        });

        // Inicializa elementos select2 em modo tag
        $(`${id} select.select2.tags`).select2({
            language: 'pt-BR',
            allowClear: this?.dataset.allowClear,
            createTag: () => null,
            tags: true,
            id: function (object) {
                return object.text;
            },
            placeholder: this?.dataset.placeholder ?? 'Selecione...'
        });

        // Inicializa elementos select2 em modo tag, com a opção de criar tags
        $(`${id} select.select2.tags.with-create-tags`).select2({
            language: 'pt-BR',
            allowClear: this?.dataset.allowClear,
            tags: true,
            id: function (object) {
                return object.text;
            },
            placeholder: this?.dataset.placeholder ?? 'Selecione...'
        });

        // Inicializa elementos select2 em modo tag, com a opção de criar novas tags na base de dados via Ajax
        // Necessário remover antes o evento select2:select, pois dentro das dialogs, o mesmo estava sendo duplicado em alguns casos
        $(`${id} select.select2.tags.with-create-tags-with-ajax`).off('select2:select select2:multiselect').select2({
            language: 'pt-BR',
            allowClear: this?.dataset.allowClear,
            createTag: function (params) {
                return {
                    id: params.term.trim(),
                    text: params.term.trim(),
                    newTag: true
                }
            },
            tags: true,
            id: function (object) {
                return object.text;
            },
            placeholder: 'Selecione ou digite um novo registro...',

        }).on('select2:select', function (event) {
            if (event.params.data.newTag) {
                const el = event.target;

                axios.post(el.dataset.url, { 'descricao': event.params.data.text})
                    .then(response => {
                        if (!response.data.success || !response.data.id) throw new Error(response.data.message);

                        $(el).find('[value="' + event.params.data.id + '"]')
                            .replaceWith('<option selected value="' + response.data.id + '">' + event.params.data.text + '</option>');

                    })
                    .catch(error => {
                        Spinner.hide();
                        showNotification(error.message ?? error.response.data ?? 'Ocorreu um erro durante a requisição!', { type: 'error'});

                        $(el).find('[value="' + event.params.data.id + '"]').remove();
                    });
            }
        });
    }

    /**
     * Inicializa o plugin do dropzone
     */
    function initDropzone() {
        $('.dropzone:not(.dz-clickable)').each(function (index, el) {
            const parentForm = $(el).parents('form')[0];

            if (!parentForm.classList.contains('dropzone-form')) {
                throw new Error('The parent form of the dropzone component must contain the dropzone-form class');
            }

            const acceptedFiles = el.dataset.acceptFiles ?? 'image/*';
            const paramName = el.dataset.inputName;
            const multipleFiles = el.hasAttribute('data-multiple-files');
            const previewsContainer = el.querySelector('.previews');
            const maxFilesize = el.dataset.maxFilesize ?? 2; //Em MB
            const message = el.dataset.message ?? (multipleFiles ? 'Clique ou arraste e solte os novos arquivos aqui' : 'Clique ou arraste o arquivo aqui');

            const fileURL = el.dataset.fileUrl;
            const fileSize = el.dataset.fileSize;
            const fileName = el.dataset.fileName;

            if (multipleFiles && (fileURL || fileSize || fileName)) {
                console.warn('A opção "multiplesFiles" é incompatível com as opções "fileURL", "fileSize" e "fileName". As mesmas serão ignoradas.');
            }

            const previewElSrc = parentForm.querySelector(`[data-input-preview=${paramName}]`);

            new Dropzone(el, {
                previewTemplate: $(el).find('template').html(),
                url: parentForm.action,
                maxFilesize,
                maxFiles: multipleFiles ? null : 1,
                acceptedFiles,
                addRemoveLinks: true,
                autoProcessQueue: false,
                previewsContainer,
                paramName,
                createImageThumbnails: !previewElSrc,
                thumbnailWidth: null,
                thumbnailHeight: null,
                thumbnailMethod: 'contain',
                hiddenInputContainer: parentForm,
                dictDefaultMessage: message,
                dictFileTooBig: 'O arquivo é muito grande (@{{filesize}}MB). Tamanho máximo suportado: @{{maxFilesize}}MB.',
                dictInvalidFileType: "Tipo de arquivo não suportado.",
                dictRemoveFile: 'Remover arquivo',

                maxfilesexceeded: function (file) {
                    this.removeAllFiles();
                    this.addFile(file);
                },

                init: function () {
                    if (fileURL) {
                        let mockFile = {name: fileName ?? paramName, size: fileSize ?? 0};
                        this.displayExistingFile(mockFile, fileURL, null, '', false);
                    }

                    this.on("addedfile", file => {
                        // Remove o input fake (se existir) para não exibir as mensagens de validação
                        this.element.querySelector('input.fake-input')?.remove();

                        //remove o input hidden que controla quando apenas vamos remover o arquivo atual
                        parentForm.querySelector(`[name^=remover_${paramName}]`)?.remove();

                        if (previewElSrc) {
                            const src = URL.createObjectURL(file);

                            if (/^video/.test(file.type)) {
                                previewElSrc.innerHTML = `
                                    <video controls class="max-h-72">
                                        <source src="${src}">
                                        Your browser does not support HTML5 video.
                                    </video>
                                `;

                            } else {
                                let classes = '';

                                if (/^image/.test(file.type)) {
                                    classes = 'max-w-full h-auto max-h-72';
                                }

                                if (/pdf$/.test(file.type)) {
                                    classes = 'w-full h-96';
                                }

                                previewElSrc.innerHTML = `
                                    <object data="${src}" type="${file.type}" class="flex flex-col items-center justify-center pb-4 ${classes}">
                                        <i class="far fa-eye-slash fa-10x text-zinc-400"></i>
                                        <p class="text-zinc-400">Não foi possível realizar o preview para este tipo de arquivo!</p>
                                    </object>
                                `;
                            }
                        }
                    });

                    this.on('removedfile', _ => {
                        //Ao remover o arquivo selecionado, cria um input hidden para remover do servidor
                        if (fileURL) {
                            parentForm.insertAdjacentHTML('beforeend', `<input type="hidden" name="remover_${paramName}" value="true">`);
                        }

                        //Caso exista o preview do arquivo selecionado, ao remover o mesmo, limpa o preview
                        previewElSrc && (previewElSrc.innerHTML = '');
                    });
                }
            });
        });

        $('.dropzone-form').off('submit').on('submit', event => {
            event.preventDefault();
            event.stopPropagation();

            const form = event.target;
            const formData = new FormData(form);
            const dropzones = getAllDropzonesInstances(form);

            dropzones.forEach((dropzone, index) => {
                // Se o campo é obrigatório, não existem arquivos selecionados está visível na tela, cria o elemento fake
                // para exibir a mensagem de validação
                if (dropzone.element.hasAttribute('data-required')
                    && !dropzone.files.length && !dropzone.previewsContainer.childElementCount
                    && dropzone.element.checkVisibility()) {
                    const input = document.createElement('input');
                    input.type = 'text';
                    input.name = `fake-input-${index}`;
                    input.required = true;
                    input.classList.add('fake-input');
                    input.style.position = 'absolute';
                    input.style.top = '50%';
                    input.style.left = '0';
                    input.style.right = '0';
                    input.style.opacity = '0';
                    input.autocomplete = 'off';

                    if (dropzone.options.maxFiles === 1) {
                        input.setCustomValidity('Selecione um arquivo!');

                    } else {
                        input.setCustomValidity('Selecione um ou mais arquivos!');
                    }

                    dropzone.element.appendChild(input);
                }

                addDropzoneFilesToFormData(dropzone, formData);
            });

            if (!form.checkValidity()) {
                form.reportValidity();

                return;
            }

            axios.post(form.action, formData)
                .then(response => {
                    const {data} = response;

                    if (!data.success) {
                        throw new Error(data.message);
                    }

                    //Se o server enviar o parâmetro para redirecionar a página, redirecionamos para a página
                    //url enviada (redirectTo) ou então atualizamos a url atual
                    if (data.redirect) {
                        window.location.replace(data.redirectTo ?? window.location.href);
                        return;
                    }

                    //Como ocorreu sucesso na requisição e não vai redirecionar a página, alteramos o label do botão de
                    //Cancelar para Fechar
                    $(form).find(':reset').html('<i class="fa fa-times"></i> Fechar');

                    showNotification(data.message ?? 'Sua solicitação foi processada com sucesso!');

                    // Caso não seja para fazer o redirect na página, podemos executar algum código JavaScript utilizando
                    // esse método.
                    window.ajaxSuccessHandler && window.ajaxSuccessHandler();

                })
                .catch(error => {
                    console.error(error.message ?? error.response.data);
                    const message = error.message ?? error.response.data ?? 'Ocorreu um erro ao processar a requisição!';

                    Spinner.hide();
                    showNotification(message, {type: 'error'});
                });
        });
    }

    function initDateRangePickerPlugin(dialog = null) {
        const parentEl = dialog ? '#' + dialog?.id : 'body';
        const el = $('.daterange');

        el.daterangepicker({
            parentEl,
            autoUpdateInput: false,
            // startDate: moment(),
            // endDate: moment().add(30, 'days'),
            showDropdowns: false,
            buttonClasses: 'btn btn-outline btn-sm',
            applyButtonClasses: 'btn-info',
            cancelButtonClasses: 'btn-default',
            locale: {
                format: 'DD/MM/YYYY',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                fromLabel: "De",
                toLabel: "Até",
                daysOfWeek: [
                    "Dom",
                    "Seg",
                    "Ter",
                    "Qua",
                    "Qui",
                    "Sex",
                    "Sáb"
                ],
                monthNames: [
                    "Janeiro",
                    "Fevereiro",
                    "Março",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro"
                ],
            }
        });

        el.on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        });

        el.on('cancel.daterangepicker', function() {
            $(this).val('');
        });
    }

    /**
     * Aplica as máscaras de formatações necessárias para os inputs
     */
    function applyInputsMasks() {
        /**
         * Formata os inputs com máscara de telefone
         */
        function phoneMask(value) {
            if (!value) return "";

            value = value.replace(/\D/g,'');
            value = value.replace(/(\d{2})(\d)/,"($1) $2");
            value = value.replace(/(\d)(\d{4})$/,"$1-$2");

            return value;
        }

        $('.phone').on('keyup', event => {
            const input = event.target;
            input.value = phoneMask(input.value);
        });

        $('.cns').mask('00.000-0');
    }

    /**
     * Adiciona o evento 'open' nas dialogs (modais)
     */
    function addOpenEventOnDialogs() {
        const OpenEvent = new CustomEvent('open');
        const Observer = new MutationObserver(recs => {
            recs.forEach(({ attributeName, target}) => {
                if (attributeName === 'open' && target.open) {
                    target.dispatchEvent(OpenEvent);
                }
            });
        });

        document.querySelectorAll('dialog').forEach( dialog => {
            Observer.observe(dialog, { attributes: true });
        });
    }

    function getAllDropzonesInstances(form) {
        if (!form) throw new Error('It is necessary to inform the reference form');

        return Array.from(form.querySelectorAll('.dropzone.dz-clickable')).map(dropzone => dropzone.dropzone);
    }

    function addDropzoneFilesToFormData(dropzone, formData) {
        let {paramName, maxFiles} = dropzone.options;

        dropzone.files.forEach((file, index) => {
            if (maxFiles === 1) {
                formData.append(paramName, file);
                return;
            }

            formData.append(paramName + '[' + index + ']', file);
        });
    }

    function scrollToActiveMenu() {
        const nav = document.querySelector('.drawer-side > aside > nav');

        if (!nav) return;

        const activeMenu = nav.querySelector('.active');
        activeMenu?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }

    function initAutoHeightTextAreas(dialog = null) {
        const parentEl = dialog ? '#' + dialog?.id : '';

        $(`${parentEl} textarea[auto-height]`)
            .each(function () {
                this.style.height = this.scrollHeight + "px";
                this.style.overflowY = "hidden";
            })
            .on("input", function () {
                this.style.height = "auto";
                this.style.height = this.scrollHeight + "px";
            });
    }

    /**
     * Desabilita os botões dos formulários durante o submit, para evitar múltiplas requisições.
     */
    $(document).on('submit', 'form', event => {
        const form = event.target;
        const buttons = form.querySelectorAll('[type=submit], [type=reset]');
        buttons.forEach(button => button.setAttribute('disabled', 'disabled'));
    })

    /**
     * Controla o comportamento do clique sobre o checkbox para selecionar todos os regitros das listagens.
     */
    $('[name=table_select_all]').on('click', event => {
        const el = event.target;
        const isChecked = el.checked;
        const table = el.closest('table');

        table.querySelectorAll('.select-record:not(:disabled)').forEach(checkbox => {
            checkbox.checked = isChecked;
        });
    });

    /**
     * Controla o comportamento do submit e do botão de limpar nos filtros das listas das páginas
     */
    $('.page-filters-form')
        .on('submit', _ => Spinner.show())
        .on('reset', function (event) {
            event.preventDefault();

            // Limpa apenas controles visíveis; hidden são preservados.
            $('.page-filters-form select:not(.reset-first)').val(null).change();
            $('.page-filters-form input:not([type=hidden], [name=itens_por_pagina])').val(null);
            $('.page-filters-form input[type=checkbox]').prop('checked', false);

            $('.page-filters-form select.reset-first').each(function () {
                $(this).val($(this).find('option:first').val()).change();
            });

            Spinner.show();
            event.currentTarget.submit();
        });

    /**
     * Controla o click sobre os checkboxes das listagens de cadastros
     */
    $(document).on('click', '[data-action=toggle-list-option]', event => {
        const checkbox = event.target;
        const url = checkbox.dataset.url;
        const value = checkbox.checked;
        const setRecordRead = checkbox.dataset.setRecordRead;

        const action = _ => {
            axios.put(url, { value })
                .then(response => {
                    const data = response.data;

                    if (!data.success) {
                        console.error(data.message);
                        showNotification(data.message, { type: 'error' });
                        checkbox.checked = !checkbox.checked;

                        return;
                    }

                    if (data.redirect) {
                        window.location.reload();

                        return;
                    }

                    showNotification(data.message);

                    if (setRecordRead) {
                        $(checkbox).parents('tr').toggleClass('font-semibold', !checkbox.checked);
                    }

                    // Se deve atualizar algum campo da tela
                    if (data.updateData) {
                        for (const item in data.updateData) {
                            $(checkbox).parents('tr').find(`[data-${item}]`).html(data.updateData[item]);
                        }
                    }

                })
                .catch (error => {
                    console.error(error);
                    Spinner.hide();
                    showNotification('Ocorreu um erro ao processar a requisição', { type: 'error' });
                });
        }

        if (!value && checkbox.attributes.hasOwnProperty('data-requires-confirmation')) {
            const message = checkbox.dataset.confirmMessage ?? 'Deseja realmente prosseguir com a operação?';
            showConfirm(message, action, { type: 'warning' });
            return;
        }

        action();
    });

    /**
     * Controla o click sobre o botão para remover registros
     */
    $(document).on('click', '[data-action=remove-records]', event => {
        const records = [];
        const elementID = event.target.dataset.id;
        let filters = [];

        // Gerencia a opção de deletar tags
        if(event.target.id === 'remove_tag') {
            filters = event.target.dataset.filter || [];
            if (filters && filters.length === 0) {
                showAlert('É necessário selecionar pelo menos uma tag nos filtros para realizar a exclusão');
                return;
            }
        }

        if (elementID) {
            records.push({ id: elementID});

        } else {
            $('[type=checkbox].select-record').each((idx, elem) => {
                if (elem.checked) {
                    records.push({ id: elem.value });
                }
            });
        }


        if (!records.length) {
            showAlert('É necessário escolher pelo menos um registro para a exclusão.', { type: 'warning' });
            return;
        }

        const button = event.target;
        const url = button.dataset.url;
        const message  = 'Esta operação irá remover os registros, tem certeza que deseja remover ' + records.length + ' registro(s)?'
        const additionalMessage = button.dataset.additionalMessage;
        const action = () => {
            axios.post(url, { '_method': 'DELETE', 'registros': records, 'filtros': filters })
                .then(response => {
                    const data = response.data;

                    if (!data.success) {
                        showNotification(data.message, { type: 'error' });
                        return;
                    }

                    window.location.href = data.redirectTo;
                })
                .catch(error => {
                    console.error(error);
                    Spinner.hide();
                    showNotification(error, { type: 'error' });
                });
        }

        showConfirm(message, action, { type: 'danger', additionalMessage });
    });

    $(document).on('change', '[data-action="change-page-size"]', event => {
        const el = event.target;
        const url = new URL(window.location.href);

        url.searchParams.set(el.dataset.param, el.value);
        url.searchParams.delete(el.dataset.pageParam);
        window.location.href = url.toString();
    });

    /**
     * Controla o click sobre o botão para restaurar registros
     */
    $(document).on('click', '[data-action=restore-records]', event => {
        const records = [];
        const elementID = event.target.dataset.id;

        if (elementID) {
            records.push({ id: elementID});

        } else {
            $('[type=checkbox].select-record').each((idx, elem) => {
                if (elem.checked) {
                    records.push({ id: elem.value });
                }
            });
        }

        if (!records.length) {
            showAlert('É necessário escolher pelo menos um registro para restaurar.', { type: 'warning' });
            return;
        }

        const button = event.target;
        const url = button.dataset.url;
        const message  = 'Esta operação irá restaurar os registros, tem certeza que deseja restaurar ' + records.length + ' registro(s)?'
        const action = () => {
            axios.put(url, { 'registros': records })
                .then(response => {
                    const data = response.data;

                    if (!data.success) {
                        showNotification(data.message, { type: 'error' });
                        return;
                    }

                    window.location.href = data.redirectTo;
                })
                .catch(error => {
                    console.error(error);
                    Spinner.hide();
                    showNotification(error, { type: 'error' });
                });
        }

        showConfirm(message, action, { type: 'warning' });
    });

    /**
     * Controla o click sobre os botões de edição dos registros
     * O evento precisa ser adicionado no documento
     */
    $(document).on('click', '[data-action=open-dialog], [data-action=open-link]', event => {
        const el = event.currentTarget;
        const action = el.dataset.action;

        if (action === 'open-dialog' && !el.dataset.dialogId) {
            throw new Error(`É necessário informar o atributo "data-dialog-id" no elemento ${el.outerHTML}!`);
        }

        axios.get(el.dataset.url)
            .then(response => {
                const data = response.data;

                if (!data.success) {
                    throw new Error(data.message);
                }

                if (action === 'open-link') {
                    if (!data.link) {
                        throw new Error('O servidor não retornou uma URL válida no campo "link".');
                    }

                    const target = el.dataset.target || '_self';

                    if (target === '_blank') {
                        window.open(data.link, '_blank');

                    } else {
                        window.location.href = data.link;
                    }

                    Spinner.hide();
                    return;
                }

                function initDialogControls() {
                    const dialog = document.getElementById(el.dataset.dialogId);

                    //remove a dialog do HTML ao fechá-la, para não "poluir" o HTML
                    dialog.addEventListener('close', _ => dialog.remove());

                    initDropzone();
                    initSummernote();
                    initSelect2Plugin(dialog);
                    initDateRangePickerPlugin(dialog);
                    applyInputsMasks();
                    initAutoHeightTextAreas(dialog);

                    dialog.showModal();
                }

                if (!data.html || !data.html.length) {
                    throw new Error('Está faltando o HTML de retorno.');
                }

                for (const item in data.updateData ?? {}) {
                    const targetEl = $(el).parents('tr').find(`[data-${item}]`);

                    if (targetEl.is('[type=checkbox]')) {
                        targetEl[0].checked = !!data.updateData[item];

                        targetEl.parents('tr').removeClass(_ => targetEl.is('[data-set-record-read]') ? 'font-semibold' : null);

                    } else {
                        targetEl.html(data.updateData[item]);
                    }
                }

                $('body').append(data.html);
                initDialogControls();
            })
            .catch(error => {
                console.error(error);
                Spinner.hide();
                showNotification(error.response?.data?.message ?? error.message ?? error ?? 'Não foi possível concluir a operação. Por favor, tente novamente!', { type: 'error' });
            });
    });

    /**
     * Controla o click sobre o thumb das imagens nas listagens
     */
    $(document).on('click', '[data-action=image-preview]', event => {
        const element = event.currentTarget;
        const contentType = element.dataset.contentType ?? 'png';
        let image = element.src;

        if (contentType === 'svg') {
            image = element.children[0];
        }

        const dialog = $(`
            <dialog id="image_preview" class="modal">
                <div class="modal-box w-auto max-w-6xl">
                    <button class="btn-close" onclick="image_preview.close()">✕</button>
                    <div class="modal-body">
                        <h2 class="page-subtitle mb-6">Preview</h2>

                        ${contentType === 'svg' ? `${image.outerHTML}` : `<img src="${image}" alt="">`}
                    </div>
                </div>
            </dialog>
        `);

        $('body').append(dialog);

        const dialogEl = dialog.get(0);

        dialogEl.showModal();

        dialogEl.addEventListener('close', _ => dialog.remove());
    });

    /**
     * Controla o submit via Ajax de formulários que não possuem o componente dropzone
     */
    $(document).on('submit', 'form.ajax-form:not(.dropzone-form)', event => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.target;
        const formData = new FormData(form);

        axios.post(form.action, formData)
            .then(response => response.data)
            .then(data => {
                if (!data.success) {
                    throw new Error(data.message);
                }

                //TODO: Podemos alterar esse método para manter a mesma lógico dos forms com dropzone (linha 453)
                data.redirecTo ? window.location.replace(data.redirectTo) : window.location.reload();

            })
            .catch(error => {
                console.error(error.response?.data ?? error.message);
                const message = error.response?.data?.message ?? error.message ?? 'Ocorreu um erro ao processar a requisição!';

                showNotification(message, { type: 'error' });
                Spinner.hide();
                form.querySelector('[type=submit]').removeAttribute('disabled');
                form.querySelector('[type=reset]').removeAttribute('disabled');
            });
    });

    /**
     * Inicializa os plugins nos inputs que estão dentro das dialogs, ao abrir as mesmas
     * Importante: Só funciona nas dialogs de inclusão. Na edição, a inicialização dos plugins é feita no método
     * "open-dialog".
     */
    $('dialog').on('open', event => {
        initDropzone();
        initSummernote();
        initSelect2Plugin(event.target);
        initDateRangePickerPlugin(event.target);
        applyInputsMasks();
        initAutoHeightTextAreas(event.target);
    });

    $(document).on('click', '[data-action=preview]', event => {
        event.preventDefault();

        const form = $(event.target).parents('form')[0];
        const serializedData = new FormData(form);
        const url = event.target.dataset.url;

        serializedData.delete('_method');

        const dropzones = getAllDropzonesInstances(form);

        dropzones.forEach(dropzone => {
            addDropzoneFilesToFormData(dropzone, serializedData);
        });

        axios.post(url, serializedData)
            .then(response => {
                const data = response.data;

                if (!data.success) {
                    throw new Error(data.message);
                }

                if (!data.html || !data.html.length) {
                    throw new Error('Está faltando o HTML de retorno.');
                }

                $('body').append(data.html);

                const dialog = document.getElementById(event.target.dataset.dialogId);

                //remove a dialog do HTML ao fechá-la, para não "poluir" o HTML
                dialog.addEventListener('close', _ => dialog.remove());
                dialog.showModal();

            })
            .catch(error => {
                console.error(error);
                Spinner.hide();
                showNotification(error.message, { type: 'error' });
            });
    });

    addOpenEventOnDialogs();
    initSelect2Plugin();
    initDateRangePickerPlugin();

    // Retrair o menu na versão desktop
    if (window.innerWidth >= 1280) {
        const menuToggle = $('.menu-toggle');
        const drawer = $('.drawer');
        const drawerSide = $('.drawer-side');
        const menuLateral = $('.menu-lateral');
        const menuLateralNav = $('.menu-lateral > nav');

        menuToggle.removeClass('hidden').addClass('flex');

        if(localStorage.getItem('menuExpanded') === 'false') {
            drawerSide.css('width', 'inherit');
            drawer.addClass('retract');

        } else {
            drawer.removeClass('retract');
            drawerSide.css('width', 'auto');
            localStorage.setItem('menuExpanded', 'true');
        }

        menuToggle.on('click', function() {
            if(localStorage.getItem('menuExpanded') === 'true') {
                localStorage.setItem('menuExpanded', 'false');
                drawerSide.css('width', 'inherit');
                drawer.addClass('retract');
                menuToggle.addClass('open');
            }
            else{
                drawer.removeClass('retract aux');
                menuToggle.removeClass('open');
                drawerSide.css('width', 'auto');
                localStorage.setItem('menuExpanded', 'true');
            }
        })

        menuLateralNav.on('mouseenter', function () {
            if(localStorage.getItem('menuExpanded') === 'false') {
                drawer.removeClass('retract').addClass('aux');
                setTimeout(scrollToActiveMenu, 100);
            }
        })

        menuLateral.on('mouseleave', function(){
            if(localStorage.getItem('menuExpanded') === 'false') {
                drawer.addClass('retract').removeClass('aux');
            }
        })
    }

    scrollToActiveMenu();
});
